import { ReactNode, useState } from "react";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import styles from "./DecisionWithModal.module.css";

type DecisionWithModalProps = {
  children: ReactNode;
  modalContent: (props: { visible: boolean; onClose: () => void }) => ReactNode;
  title: string;
  leadingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  className?: string;
};

function DecisionWithModal({
  children,
  modalContent,
  title,
  leadingIcon,
  className,
}: DecisionWithModalProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className={className}>
      <FixaListViewItem
        className={styles["modalTrigger"]}
        title={title}
        leadingIcon={leadingIcon}
        control="navigational"
        controlIcon={null}
        type="button"
        showDivider={false}
        onClick={() => setModalOpen(true)}
      />
      {children}
      {modalContent({
        visible: modalOpen,
        onClose: () => setModalOpen(false),
      })}
    </div>
  );
}

export default DecisionWithModal;
